import { motion } from "framer-motion";

const LoadingScreen = () => (
  <div style={{
    minHeight: '100dvh', background: '#FFFEF9',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', gap: 28,
  }}>
    <motion.div
      animate={{ y: [0, -3, 0] }}
      transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
      style={{ textAlign: 'center' }}
    >
      <img src="/logo-book.png" alt="YOU" style={{ width: 120, height: 120, objectFit: 'contain', display: 'block', margin: '0 auto 12px' }} />
      <img src="/logo-you-text.png" alt="YOU" style={{ height: 40, objectFit: 'contain', display: 'block', margin: '0 auto 6px' }} />
      <img src="/logo-subtitle.png" alt="Your Own Understanding" style={{ height: 16, objectFit: 'contain', display: 'block', margin: '0 auto' }} />
    </motion.div>
    {/* Pulsing dot */}
    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
      {[0, 1, 2].map(i => (
        <motion.div
          key={i}
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 1.2, repeat: Infinity, delay: i * 0.2 }}
          style={{ width: 6, height: 6, borderRadius: '50%', background: '#448AFF' }}
        />
      ))}
    </div>
  </div>
);

export default LoadingScreen;
